module.exports = __webpack_public_path__ + "static/media/warning.a93a2fac.svg";